module.exports = function () {
    $(document).ready(function () {

        var max_fields = 10; //maximum input boxes allowed

        var file_wrapper = $(".input_file_fields_wrap"); // Fields file_wrapper
        var add_file_button = $(".add_file_field_button"); // Add button ID

        /**
         * Files fields
         */
        var y = 1;
        $(add_file_button).click(function (e) {
            e.preventDefault();
            if (y < max_fields) { // max input box allowed
                y++; // text box increment
                $('#filesCounter').val(y);
                $(file_wrapper).append('<div style="margin-bottom: 3px;"><input type="file" name="files[]" class="form-control" required /><a href="#" class="remove_field">Remove</a></div>'); //add input box
            }
        });

        $(file_wrapper).on("click", ".remove_field", function (e) {
            e.preventDefault();
            $(this).parent('div').remove();
            y--;
            $('#filesCounter').val(y);
        });

    });
}();
